import { render, staticRenderFns } from "./CreateBannerDialog.vue?vue&type=template&id=1032db28&scoped=true&lang=pug&"
import script from "./CreateBannerDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateBannerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1032db28",
  null
  
)

export default component.exports